import { render, staticRenderFns } from "./MilestoneSection.vue?vue&type=template&id=65991fa4&scoped=true&"
import script from "./MilestoneSection.vue?vue&type=script&lang=js&"
export * from "./MilestoneSection.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneSection.vue?vue&type=style&index=0&id=65991fa4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65991fa4",
  null
  
)

export default component.exports